import React from 'react';
import ReactDOM from 'react-dom/client';
import Routes from './routes';

import i18n from './i18n/config';
import './styles/global.css';
import { CurrencyProvider } from "./contexts/CurrencyContext";
import { GlobalStateProvider } from "./contexts/GlobalStateContext";
import CookieConsent from './components/CookieConsent';
import { resolveDomainBootstrapConfig } from './services/domainBootstrap';


const root = ReactDOM.createRoot(document.getElementById('root'));

(async () => {
  let initialCurrency;
  try {
    const cfg = await resolveDomainBootstrapConfig();
    if (cfg?.lang) {
      try {
        const savedLang = localStorage.getItem('lang');
        // Prioriza o idioma escolhido pelo usuário (persistido) sobre o idioma do domínio
        if (!savedLang) {
          await i18n.changeLanguage(cfg.lang);
        }
      } catch (_) {
        // Ignore errors when accessing localStorage
      }
    }
    if (cfg?.currency) {
      try {
        const savedCurrency = localStorage.getItem('moedaSelecionada');
        if (savedCurrency) {
          initialCurrency = savedCurrency;
        } else {
          initialCurrency = cfg.currency;
        }
      } catch (_) {
        initialCurrency = cfg.currency;
      }
    }
  } catch (_) {
    // Ignore errors when resolving domain config
  }

  root.render(
    <React.StrictMode>
      <GlobalStateProvider>
        <CurrencyProvider initialCurrency={initialCurrency}>
          <Routes />
          <CookieConsent />
        </CurrencyProvider>
      </GlobalStateProvider>
    </React.StrictMode>
  );
})();
